module.exports = __webpack_public_path__ + "img/image_list_2.7fc345b0.png";